<template>
  <div>
    <!--<v-parallax :src="require('@/assets/wallpaper/7.jpg')" height="350">
      <v-layout align-center column justify-center>
        <img src="@/assets/stern.png" style="padding:10px;">
      </v-layout>
    </v-parallax>
    <v-container>Hallo!<br><br><br><br><br></v-container>
    <v-parallax :src="require('@/assets/wallpaper/2.jpg')" :height="350">
      <v-layout align-center column justify-center>
        sdffdsfds
      </v-layout>
    </v-parallax>-->
    
    <v-parallax :src="require('@/assets/wallpaper/2.jpg')" :height="ih">
      <v-layout justify-space-around column fill-height white--text>
        <br>
      <div class="center">
        <img src="@/assets/stern.png">
        <!--<br><span class="display-1">Stamm 33 Braunschweig</span>-->
      </div>
      
      <div class="center">
        <span class="display-3">Wir lieben das Abenteuer</span><br>
        <span class="headline">Erfahre mehr &uuml;ber uns!</span>
        
      </div>
      <br>
      </v-layout>
    </v-parallax>
    <v-container>
      <br>
      <v-flex class="subheading" xs12 sm10  offset-xs0 offset-sm1>
        <span class="headline">Herzlich Willkommen beim Stamm 33 Braunschweig</span><br><br>
        <p>Keine Lust auf Langeweile? Willst du stattdessen was Richtiges erleben? Dann bist du genau richtig bei den Royal Rangers. Ein Mal in der Woche treffen sich die Pfadfinder, um gemeinsam Abenteuer zu erleben. Ob im Wald oder in der Flur – die Kinder lernen ganz praktisch den Umgang mit Kompass und Karte, sie machen Feuer und versuchen sich an Knoten und Bünden.</p>
        <p>Doch nicht das praktische Lernen steht bei uns im Vordergrund, sondern das lockere und spaßige Zusammensein in den Teams. Hier werden Freundschaften unter den Kindern geschlossen, welche sich durch die unterschiedlichsten Aufgaben und Unternehmungen behaupten müssen. Dabei werden Teamgeist und vorhandene Freundschaften gestärkt und auch neue Freundschaften geschlossen. Ein weiteres Ziel, was die Kinder mit auf den Weg gegeben werden soll, ist die Verantwortung, welche sie übernehmen sollen. Hierbei wird gerade auf die Schwächeren Rücksicht genommen, da eines der Royal Rangers Mottos lautet: Der Große schützt den Kleinen.</p>
        <p>Neben vielfältigen Aktionen geht es darum, die Kinder für den christlichen Glauben zu begeistern. Wir machen uns mit Gott auf den Weg und entdecken die Schätze, die er für uns bereithält. Das Gefühl, bei Mondschein um ein kleines Feuer zu sitzen, zusammen Lieder zu singen und den freien Sternenhimmel zu beobachten, lohnt sich zu erleben – lass es dir nicht entgehen!<br/>Wenn du Lust hast, schau einfach vorbei. Jeder ist herzlich willkommen, vollkommen egal aus welchem sozialen oder kulturellen Hintergrund er kommt.<br/>Wir freuen uns auf deinen Besuch!</p>
      </v-flex>
      <br>
    </v-container>
    
    <!--<v-layout align-center justify-space-around column fill-height class="headerbox white--text">
      <br >
      <div class="center">
        <img src="@/assets/stern.png" style="">
      </div>
      
      
      <div class="center">
        <span class="display-3">Wir lieben das Abenteuer</span><br>
        <span class="headline">Erfahre mehr &uuml;ber uns!</span>
        
      </div>
      <br>
    </v-layout>-->
    
    
    
    <!--<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>-->
    
  </div>
</template>

<script>
  export default {
    data: () => ({
      ih: window.innerHeight
    })
  }
</script>

<style>
.v-parallax__content{
  padding:0px;
  background-color:rgba(0,0,0,0.3)
}
.center{
  text-align: center;
}

.headerbox{
  min-height:100vh;
  background-image: url('../../assets/wallpaper/6.jpg');
  background-repeat:no-repeat;
  background-position: right top;
  background-size: cover;
  background-attachment: fixed;
  padding:10px;
}

.headerbox img{
  padding:10px;
  background: -moz-radial-gradient(center, ellipse cover,  rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.45) 18%, rgba(0,0,0,0) 74%, rgba(0,0,0,0) 100%);
  background: -webkit-radial-gradient(center, ellipse cover,  rgba(0,0,0,0.45) 0%,rgba(0,0,0,0.45) 18%,rgba(0,0,0,0) 74%,rgba(0,0,0,0) 100%);
  background: radial-gradient(ellipse at center,  rgba(0,0,0,0.45) 0%,rgba(0,0,0,0.45) 18%,rgba(0,0,0,0) 74%,rgba(0,0,0,0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#73000000', endColorstr='#00000000',GradientType=1 );
}
</style>
